(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-buy-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-form')) {
    customElements.define(
      'product-buy-form',
      class ProductBuyForm extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.section;
          this.hideErrors = this.dataset.hideErrors === 'true';
          this.form = document.getElementById(`product-form-${this.sectionId}`);
          this.form?.addEventListener('submit', this.onSubmit.bind(this));
        }

        onSubmit(event) {
          event.preventDefault();
          if (!this.form || !this.form.reportValidity()) return;

          const formData = new FormData(this.form);
          formData.append(
            'sections',
            this.getSectionsToRender()
              .filter((section) => document.getElementById(section.id))
              .map((section) => section.section)
          );
          formData.append('sections_url', window.location.pathname);

          this.setLoading(true);
          this.clearError();
          this.openCartDrawerOptimistically();

          fetch(window.theme.routes.cart_add_url, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/javascript',
            },
            body: formData,
          })
            .then((response) => response.json())
            .then((state) => {
              if (state.status) {
                this.showError(state.description);
                this.rollbackCartDrawer();
                return;
              }

              this.renderCartSections(state);
              document.dispatchEvent(
                new CustomEvent('cart:item-added', {
                  detail: {
                    product: Object.prototype.hasOwnProperty.call(state, 'items') ? state.items[0] : state,
                  },
                })
              );
            })
            .catch((error) => {
              console.error(error);
              this.rollbackCartDrawer();
            })
            .finally(() => {
              document.getElementById('Cart-Drawer')?.classList.remove('is-updating', 'is-updating--cover');
              this.setLoading(false);
            });
        }

        getSectionsToRender() {
          return [
            { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
            { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
            { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
          ];
        }

        renderCartSections(state) {
          this.getSectionsToRender().forEach((section) => {
            const root = document.getElementById(section.id);
            const sectionHtml = state.sections?.[section.section];
            if (!root || !sectionHtml) return;

            const source = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector(section.selector);
            const destination = root.querySelector(section.selector) || root;
            if (source && destination) destination.innerHTML = source.innerHTML;
          });

          if (typeof CartDrawer !== 'undefined') new CartDrawer();
          if (typeof Cart !== 'undefined') new Cart().renderContents(state);

          const drawer = document.getElementById('Cart-Drawer');
          if (drawer) {
            document.body.classList.add('open-cc', 'open-cart');
            drawer.classList.add('active');
            document.dispatchEvent(new CustomEvent('cart-drawer:open'));
          } else {
            document.body.classList.remove('open-cc');
          }
        }

        openCartDrawerOptimistically() {
          const drawer = document.getElementById('Cart-Drawer');
          const productDrawer = document.getElementById('Product-Drawer');
          if (!drawer || productDrawer?.contains(this)) return;

          document.body.classList.add('open-cc', 'open-cart');
          drawer.classList.add('active', 'is-updating');
          if (drawer.querySelector('.cart-drawer__empty-cart')) drawer.classList.add('is-updating--cover');
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
          this.optimisticOpen = true;
        }

        rollbackCartDrawer() {
          if (!this.optimisticOpen) return;
          const drawer = document.getElementById('Cart-Drawer');
          drawer?.classList.remove('active', 'is-updating', 'is-updating--cover');
          document.body.classList.remove('open-cart', 'open-cc');
          this.optimisticOpen = false;
        }

        setLoading(isLoading) {
          document.querySelectorAll('.single-add-to-cart-button').forEach((button) => {
            button.classList.toggle('loading', isLoading);
            button.toggleAttribute('aria-disabled', isLoading);
          });
        }

        clearError() {
          this.showError(false);
        }

        showError(message) {
          if (this.hideErrors) return;
          const wrapper = this.querySelector('.product-form__error-message-wrapper');
          const messageElement = wrapper?.querySelector('.product-form__error-message');
          if (!wrapper || !messageElement) return;

          wrapper.toggleAttribute('hidden', !message);
          if (message) messageElement.textContent = message;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker-new"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-variant-picker-new')) {
    customElements.define(
      'product-variant-picker-new',
      class ProductVariantPickerNew extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.section;
          this.productFormId = this.dataset.productFormId;
          this.updateUrl = this.dataset.updateUrl === 'true';
          this.variants = JSON.parse(this.querySelector('[data-variants-json]').textContent);
          this.selectedOptions = this.getSelectedOptionsFromDom();
          this.currentVariant = this.findVariant();
          this.abortController = null;
          this.requestId = 0;

          this.addEventListener('click', this.onOptionClick.bind(this));
          this.addEventListener('change', this.onOptionChange.bind(this));
          this.applyLocalizedSwatchImages();
          this.updateAvailability();
          this.commitState({ renderInfo: false });
          window.requestAnimationFrame(() => {
            this.updateMedia();
          });
        }

        onOptionClick(event) {
          const button = event.target.closest('[data-pdp-new-option-value]');
          if (!button || !this.contains(button)) return;

          event.preventDefault();
          const optionIndex = Number(button.dataset.optionIndex);
          this.selectedOptions[optionIndex] = button.dataset.value;
          this.currentVariant = this.findVariant();
          this.commitState({ renderInfo: true });
        }

        onOptionChange(event) {
          const select = event.target.closest('[data-pdp-new-option-select]');
          if (!select || !this.contains(select)) return;

          const optionIndex = Number(select.dataset.optionIndex);
          this.selectedOptions[optionIndex] = select.value;
          this.currentVariant = this.findVariant();
          this.commitState({ renderInfo: true });
        }

        getSelectedOptionsFromDom() {
          return Array.from(this.querySelectorAll('[data-pdp-new-option]')).map((option) => {
            return (
              option.querySelector('[data-pdp-new-option-select]')?.value ||
              option.querySelector('[data-pdp-new-option-value].is-active')?.dataset.value
            );
          });
        }

        findVariant() {
          return this.variants.find((variant) => {
            return variant.options.every((option, index) => option === this.selectedOptions[index]);
          });
        }

        commitState({ renderInfo }) {
          this.updateButtons();
          this.updateCurrentLabels();
          this.updateAvailability();
          this.updateVariantInput();
          this.updateAddButton();
          this.updateMedia();
          this.updatePickupAvailability();
          this.updateUrlState();
          this.updateStickyPicker();
          this.dispatchVariantChange();
          if (renderInfo) this.renderProductInfo();
        }

        updateButtons() {
          this.querySelectorAll('[data-pdp-new-option]').forEach((option) => {
            const optionIndex = Number(option.dataset.optionIndex);
            const select = option.querySelector('[data-pdp-new-option-select]');
            if (select && select.value !== this.selectedOptions[optionIndex])
              select.value = this.selectedOptions[optionIndex];

            option.querySelectorAll('[data-pdp-new-option-value]').forEach((button) => {
              const isActive = button.dataset.value === this.selectedOptions[optionIndex];
              button.classList.toggle('is-active', isActive);
              button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });
          });
        }

        updateCurrentLabels() {
          this.querySelectorAll('[data-pdp-new-option]').forEach((option) => {
            const optionIndex = Number(option.dataset.optionIndex);
            const label = option.querySelector('[data-current-value]');
            if (label) label.textContent = this.selectedOptions[optionIndex] || '';
          });
        }

        updateAvailability() {
          this.querySelectorAll('[data-pdp-new-option]').forEach((option) => {
            const optionIndex = Number(option.dataset.optionIndex);
            const select = option.querySelector('[data-pdp-new-option-select]');

            if (select) {
              Array.from(select.options).forEach((optionElement) => {
                const testOptions = [...this.selectedOptions];
                testOptions[optionIndex] = optionElement.value;
                const matchingVariant = this.variants.find((variant) => {
                  return variant.options.every((value, index) => value === testOptions[index]);
                });
                optionElement.disabled = false;
              });
            }

            option.querySelectorAll('[data-pdp-new-option-value]').forEach((button) => {
              const testOptions = [...this.selectedOptions];
              testOptions[optionIndex] = button.dataset.value;
              const matchingVariant = this.variants.find((variant) => {
                return variant.options.every((value, index) => value === testOptions[index]);
              });
              const isMissingCombination = !matchingVariant;
              const isSoldOut = matchingVariant && !matchingVariant.available;
              button.classList.toggle('is-unavailable-combination', isMissingCombination);
              button.classList.toggle('is-soldout', isMissingCombination || isSoldOut);
              button.setAttribute('aria-disabled', isMissingCombination || isSoldOut ? 'true' : 'false');
            });
          });
        }

        updateStickyPicker() {
          document.querySelectorAll(`variant-selects[data-section="${this.sectionId}"]`).forEach((picker) => {
            if (!picker.id || picker.id.indexOf('--sticky') === -1) return;
            this.selectedOptions.forEach((value, index) => {
              const fieldset = picker.querySelector(`[data-index="option${index + 1}"]`);
              const select = fieldset?.querySelector('select');
              if (select) {
                select.value = value;
                return;
              }
              const input = Array.from(fieldset?.querySelectorAll('input[type="radio"]') || []).find(
                (radio) => radio.value === value
              );
              if (input) input.checked = true;
            });
            if (typeof picker.updateOptions === 'function') picker.updateOptions();
            if (typeof picker.updateMasterId === 'function') picker.updateMasterId();
            if (typeof picker.updateVariantText === 'function') picker.updateVariantText();
            if (typeof picker.setDisabled === 'function') picker.setDisabled();
          });
        }

        updateVariantInput() {
          const productForms = document.querySelectorAll(
            `#${CSS.escape(this.productFormId)}, #product-form-installment`
          );
          productForms.forEach((form) => {
            const input = form.querySelector('[name="id"]');
            if (!input) return;
            if (!this.currentVariant) {
              input.value = '';
              return;
            }
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        updateAddButton() {
          const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
          submitButtons.forEach((button) => {
            const text = button.querySelector('.single-add-to-cart-button--text');
            const isAvailable = this.currentVariant && this.currentVariant.available;
            button.toggleAttribute('disabled', !isAvailable);
            button.classList.toggle('sold-out', !isAvailable);
            button.classList.remove('loading');
            if (text)
              text.textContent = this.currentVariant
                ? isAvailable
                  ? window.theme.variantStrings.addToCart
                  : window.theme.variantStrings.soldOut
                : window.theme.variantStrings.unavailable;
          });
        }

        updateMedia() {
          if (!this.currentVariant || !this.currentVariant.featured_media) return;
          const gallery = document.querySelector(`#MediaGallery-${this.sectionId}`);
          const slider = gallery?.querySelector('#Product-Slider');
          if (!slider) return;

          const mediaId = `${this.sectionId}-${this.currentVariant.featured_media.id}`;
          const activeMedia = slider.querySelector(`[data-media-id="${mediaId}"]`);
          if (!activeMedia) return;

          slider.querySelectorAll('[data-media-id]').forEach((element) => element.classList.remove('is-active'));
          activeMedia.classList.add('is-active');
          activeMedia.parentElement.prepend(activeMedia);
          this.updateColorRelatedMedia(gallery, slider);
        }

        updateColorRelatedMedia(gallery, slider) {
          const currentAlt = this.currentVariant?.featured_media?.alt || '';
          const currentColor = (currentAlt.match(/\*\*(.*?)\*\*/)?.[1] || '').toLowerCase().trim();
          gallery.querySelectorAll('[data-color-info]').forEach((media) => {
            const mediaColor = ((media.dataset.colorInfo || '').match(/\*\*(.*?)\*\*/)?.[1] || '').toLowerCase().trim();
            if (!mediaColor || !currentColor) {
              media.classList.remove('color-info-hide');
            } else {
              media.classList.toggle('color-info-hide', mediaColor !== currentColor);
            }
          });
          this.updateMediaPagination(gallery, slider);
        }

        updateMediaPagination(gallery, slider) {
          const visibleSlides = Array.from(slider.querySelectorAll('[data-media-id]')).filter((slide) => {
            return !slide.classList.contains('color-info-hide');
          });
          const activeIndex = Math.max(
            0,
            visibleSlides.findIndex((slide) => slide.classList.contains('is-active'))
          );

          gallery.querySelectorAll('.product-images-buttons').forEach((pagination) => {
            const current = pagination.querySelector('.slider-counter--current');
            const total = pagination.querySelector('.slider-counter--total');
            const prev = pagination.querySelector('.slider-button--prev');
            const next = pagination.querySelector('.slider-button--next');

            if (current) current.textContent = String(activeIndex + 1);
            if (total) total.textContent = String(visibleSlides.length);
            if (prev) prev.toggleAttribute('disabled', activeIndex <= 0);
            if (next) next.toggleAttribute('disabled', activeIndex >= visibleSlides.length - 1);
          });
        }

        applyLocalizedSwatchImages() {
          const mapEl = this.querySelector('[data-swatch-map]');
          const colorButtons = Array.from(this.querySelectorAll('[data-handle="color"] [data-pdp-new-option-value]'));
          if (!mapEl || !colorButtons.length) return;

          let swatchMap;
          try {
            swatchMap = JSON.parse(mapEl.textContent);
          } catch (error) {
            return;
          }

          const colorValues = new Set(colorButtons.map((button) => button.dataset.value.toLowerCase().trim()));
          const bridge = {};
          this.variants.forEach((variant) => {
            const alt = variant.featured_media?.alt || '';
            const english = (alt.match(/\*\*(.*?)\*\*/)?.[1] || '').toLowerCase().trim();
            if (!english) return;

            (variant.options || []).forEach((option) => {
              const key = String(option).toLowerCase().trim();
              if (colorValues.has(key)) bridge[key] = english;
            });
          });

          let swatchBaseUrl = '';
          Object.keys(swatchMap).some((key) => {
            const image = swatchMap[key]?.image;
            if (image && image.indexOf('/') > -1) {
              swatchBaseUrl = image.slice(0, image.lastIndexOf('/') + 1);
              return true;
            }
            return false;
          });

          colorButtons.forEach((button) => {
            const raw = button.dataset.value.toLowerCase().trim();
            const english = bridge[raw] || raw;
            const info = swatchMap[english] || swatchMap[raw];

            if (info?.image) {
              button.style.setProperty('--option-color', 'var(--bg-body)');
              button.style.setProperty('--option-color-image', `url('${info.image}')`);
            } else if (info?.color) {
              button.style.setProperty('--option-color', info.color);
              button.style.removeProperty('--option-color-image');
            } else if (swatchBaseUrl && english) {
              this.applyConstructedSwatch(button, swatchBaseUrl, english);
            }
          });
        }

        applyConstructedSwatch(button, baseUrl, english) {
          const slug = english.replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
          if (!slug) return;

          const cleanBase = baseUrl.split('?')[0];
          const exts = ['png', 'jpg', 'jpeg', 'webp'];
          let index = 0;
          const tryNext = () => {
            if (index >= exts.length) return;
            const url = `${cleanBase}${slug}.${exts[index++]}`;
            const image = new Image();
            image.onload = () => {
              button.style.setProperty('--option-color', 'var(--bg-body)');
              button.style.setProperty('--option-color-image', `url('${url}')`);
            };
            image.onerror = tryNext;
            image.src = url;
          };
          tryNext();
        }

        updatePickupAvailability() {
          const pickup = document.querySelector('.pickup-availability-wrapper');
          if (!pickup) return;
          if (this.currentVariant && this.currentVariant.available) {
            pickup.fetchAvailability?.(this.currentVariant.id);
          } else {
            pickup.removeAttribute('available');
            pickup.innerHTML = '';
          }
        }

        updateUrlState() {
          if (!this.currentVariant || !this.updateUrl) return;
          window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }

        renderProductInfo() {
          if (!this.currentVariant) return;
          this.requestId += 1;
          const requestId = this.requestId;
          if (this.abortController) this.abortController.abort();
          this.abortController = new AbortController();

          const sections = this.getSectionsToRender();
          fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`, {
            signal: this.abortController.signal,
          })
            .then((response) => response.text())
            .then((responseText) => {
              if (requestId !== this.requestId) return;
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              sections.forEach((id) => {
                const destination = document.getElementById(id);
                const source = html.getElementById(id);
                if (source && destination) destination.innerHTML = source.innerHTML;
                const price = document.getElementById(id);
                const priceFixed = document.getElementById(id + '--sticky');
                if (price) price.classList.remove('visibility-hidden');
                if (priceFixed) priceFixed.classList.remove('visibility-hidden');
              });
              this.updateAddButton();
              this.updateUrlState();
            })
            .catch((error) => {
              if (error.name !== 'AbortError') console.error(error);
            });
        }

        getSectionsToRender() {
          return [
            `price-${this.sectionId}`,
            `price-${this.sectionId}--sticky`,
            `product-image-${this.sectionId}--sticky`,
            `inventory-${this.sectionId}`,
            `sku-${this.sectionId}`,
            `quantity-${this.sectionId}`,
          ];
        }

        dispatchVariantChange() {
          document.dispatchEvent(
            new CustomEvent('product:variant-change', {
              detail: {
                variant: this.currentVariant,
                sectionId: this.sectionId,
              },
            })
          );
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
